import activeApiCall from './active';
import createApiCall from './create';
import deleteApiCall from './delete';
import detailApiCall from './detail';
import editApiCall from './edit';
import listApiCall from './list';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  edit: editApiCall,
  create: createApiCall,
  delete: deleteApiCall,
  active: activeApiCall,
};

export default ApiCall;
